import { createSlice } from '@reduxjs/toolkit';
import { mockConstructions } from '@mocks/insaatlar';

const initialState = {
    selectedConstruction: null, // null = Tüm İnşaatlar
    constructions: mockConstructions,
    showAllConstructions: true,
};

const constructionSlice = createSlice({
    name: 'construction',
    initialState,
    reducers: {
        setSelectedConstruction: (state, action) => {
            state.selectedConstruction = action.payload;
            state.showAllConstructions = action.payload === null;
        },
        clearSelectedConstruction: (state) => {
            state.selectedConstruction = null;
            state.showAllConstructions = true;
        },
        setConstructions: (state, action) => {
            state.constructions = action.payload;
        },
        selectAllConstructions: (state) => {
            state.selectedConstruction = null;
            state.showAllConstructions = true;
        },
    },
});

export const {
    setSelectedConstruction,
    clearSelectedConstruction,
    setConstructions,
    selectAllConstructions
} = constructionSlice.actions;

export default constructionSlice.reducer;
